<script>
  import blocksToHtml from '@sanity/block-content-to-html'
  import { beskrivelse } from '../../stores/beskrivelse'
  import Nrk from '../Nrk.svelte'
  import Logo from './logo.svelte'
</script>

<style>
  .content {
    max-width: 800px;
    margin: 28px auto;
    padding: 0 6px;
  }

  .text {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: var(--secondary);
    margin-top: -12px;
  }

  @media (max-width: 600px) {
    .content {
      margin: 18px auto 28px;
    }
    .text {
      font-size: 17px;
    }
  }
</style>

<Nrk space="front" />
<div class="content">
  <Logo />
  <div class="text">
    {@html `${blocksToHtml({ blocks: $beskrivelse })}`}
  </div>
</div>
